import type { StateCell as StateData } from "../../../api/work";
import { AgeStrip } from "./AgeStrip";
import { TRENDS_TREND_COLORS } from "./pipelineColors";
import { PIPELINE } from "./pipelineGeometry";

interface Props {
  x: number;
  width: number;
  heightCell: number;   // WIP-proportional
  state: StateData;
  reworkThreshold?: number;
  isBottleneck?: boolean;
}

const CELL_FILL = "#1a1f28";
const CELL_STROKE = "#252836";

export function StateCell({
  x, width, heightCell, state,
  reworkThreshold = 3,
  isBottleneck = false,
}: Props) {
  const y = PIPELINE.cellBaselineY - heightCell;
  const isRework = state.rework_count >= reworkThreshold;

  const countFontSize = heightCell >= 22 ? 10 : 8;
  const countY = y + heightCell / 2 + 4;

  return (
    <g>
      {/* Cell background */}
      <rect
        x={x} y={y}
        width={width} height={heightCell}
        fill={CELL_FILL}
        stroke={isBottleneck ? TRENDS_TREND_COLORS.bottleneckOutline : CELL_STROKE}
        strokeWidth={isBottleneck ? 1 : 0.5}
        rx={2}
      />

      {/* Count */}
      <text
        x={x + width / 2} y={countY}
        fontFamily="Inter, -apple-system, sans-serif"
        fontSize={countFontSize}
        fontWeight={isBottleneck ? 700 : 600}
        fill={isBottleneck ? TRENDS_TREND_COLORS.bottleneckCount : "#e2e4ea"}
        textAnchor="middle"
      >
        {state.count}
      </text>

      {/* How old what sits here is: fresh / mid / stale */}
      <AgeStrip
        x={x}
        baselineY={PIPELINE.cellBaselineY}
        width={width}
        ages={state.age_distribution}
      />

      {/* Tiny rework chip in top-right */}
      {isRework && heightCell >= 14 && (
        <text
          x={x + width - 3} y={y + 8}
          fontFamily="Inter, -apple-system, sans-serif"
          fontSize={7} fontWeight={600}
          fill="#ef5f5f"
          textAnchor="end"
        >
          ×{state.rework_count}
        </text>
      )}

      {/* State name label below */}
      <text
        x={x + width / 2} y={PIPELINE.stateLabelY}
        fontFamily="Inter, -apple-system, sans-serif"
        fontSize={7} fontWeight={500}
        fill="#8b8fa3"
        textAnchor="middle"
      >
        {state.name.toUpperCase()}
      </text>
    </g>
  );
}
